// extracted by mini-css-extract-plugin
export default {"content":"PhoneCallNoticePopup_content__kjcdQ","dateContainer":"PhoneCallNoticePopup_dateContainer__GUkNw","label":"PhoneCallNoticePopup_label__AUmIf"};